import { render, staticRenderFns } from "./logistics-list.vue?vue&type=template&id=317def10&"
import script from "./logistics-list.vue?vue&type=script&lang=js&"
export * from "./logistics-list.vue?vue&type=script&lang=js&"
import style0 from "./logistics-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports